import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventsApiService {
  constructor(private http: HttpClient) {}

  getEventDetails = (eventId: string) => this.http.get<EventDetails>(`rest-api/v1/companies/0/events/${eventId}`);
  getEventPartnerCategories = () =>
    this.http.get<{label: string; value: number}[]>(`rest-api/v1/admin/events/partner-categories`);
  putBackgroundMovie = (eventId: string, movie: string) =>
    this.http.put(`rest-api/v1/admin/events/${eventId}/background_movie`, {movie});
  deleteBackgroundMovie = (eventId: string) =>
    this.http.delete(`rest-api/v1/admin/events/${eventId}/background_movie`);
}
export interface EventDetails {
  id: number;
  pf_id: number;
  fb_id: string;
  fb_page: null;
  name: string;
  subtitle: null;
  event_group: EventGroup[];
  event_group_id: number;
  venue: EventGroup[];
  venue_id: number;
  ticket_link: string;
  start: Date;
  end: Date;
  created_at: Date;
  days: Day[];
  category: string;
  category_ids: number[];
  location: Location;
  address: null;
  info: Info;
  movie: string;
  web_page: null;
  is_verified: boolean;
  is_cancelled: boolean;
  published_at: Date;
  location_type: string;
  profile_photo: string;
  cover_photo: string;
  map_photo: null;
  lineup_complete: boolean;
  timetable_released: boolean;
  timetable_release_date: null;
  event_map_release_date: null;
  supported_languages: string[];
  generate_share_links: boolean;
  share_links: ShareLink[];
  music_style: string;
  music_styles: string[];
  event_map: null;
  is_cancel_request_sent: boolean;
  partner_category: number;
  last_event_update: Date;
  is_managing_company: boolean;
  authorized_companies: any[];
  company: number;
  company_name: string;
  secondary_photo: string;
  external_ticket_link: string;
  event_alias_names: string;
  likes_count: number;
  site_url: string;
  ticketing_connected: boolean;
  pixels: any[];
  background_movie: string | null;
  partyflock_campaign_link: string;
}

export interface Day {
  id: number;
  day: Date;
  start: string;
  end: string;
  performance_start: Date;
  performance_end: Date;
}

export interface EventGroup {
  id: number;
  name: string;
  thumbnail: string;
}

export interface Info {
  selected_language: string;
  nl: string;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface ShareLink {
  bitly_general: string;
  bitly_event: string;
  clicks: number;
  source: string;
  label: null;
}
